// Rimosso 20190408 - Da' errore e interferisce con i click sulla form "Iscriviti a Guida Mandarda"
// Ref. https://github.com/ftlabs/fastclick/issues/510
// Ref. https://developers.google.com/web/updates/2013/12/300ms-tap-delay-gone-away
// Fastclick
//window.addEventListener('load', function() {
//    new FastClick(document.body);
//}, false);

$(document).ready(function () {

	//Smooth anchor scroll landing

	$('a.anchor:not([href="#"])').click(function () {
		if (
			location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") &&
			location.hostname == this.hostname
		) {
			var target = $(this.hash);
			target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
			if (target.length) {
				$("html, body").animate(
					{
						scrollTop: target.offset().top - 175,
					},
					1000
				);
				return false;
			}
		}
	});

	// Shrinking header
	var addBackground = 10;

	$(window).scroll(function () {
		var scroll = getCurrentScroll();
		if (scroll >= addBackground) {
			$(".header-wrap").addClass("whiteBg");
			//$('path').attr('fill', '#ccc');
		} else {
			$(".header-wrap").removeClass("whiteBg");
		}
	});

	function getCurrentScroll() {
		return window.pageYOffset || document.documentElement.scrollTop;
	}

	$(".two-blocks.overlapped a.btn-secondary").on("mouseover", function (e) {
		$(".two-blocks__img").addClass("move");
	});

	$(".two-blocks.overlapped a.btn-secondary").on("mouseout", function (e) {
		$(".two-blocks__img").removeClass("move");
	});

	//Accordion

	/* var title = document.querySelectorAll(".accordion__header");
	for (var i = 0; i < title.length; i++) {
		title[i].classList.add("js-header");
		//console.log(title[i].classList);
	}

	var copy = document.querySelectorAll(".accordion__content");
	for (var i = 0; i < copy.length; i++) {
		copy[i].classList.add("js-content");
		//console.log(copy[i].classList);
	}

	$(".accordion .js-content").slideDown();
	var $title = $(".accordion .js-header");
	$title.click(function () {
		$(this).next(copy).slideToggle();
		//$(this).parent().siblings().children().next().slideUp();
		$(this).toggleClass("active");
		//$(this).parent().siblings().children().removeClass('active');
		return false;
	}); */
    $(".js-header").on("click", function (e) {
        e.preventDefault();

        var $btn = $(this); // $(this) è il button.js-header
        var $content = $("#" + $btn.attr("aria-controls"));
        
        // Verifica se è attualmente espanso
        var isExpanded = $btn.attr("aria-expanded") === "true";

        // Toggle ARIA (cambia l'aspetto del CSS tramite :after)
        $btn.attr("aria-expanded", !isExpanded);
        
        // Animazione
        $content.stop(true, true).slideToggle(300);
    });
	// Modal

	//al caricamento pagina
	//$(".js .overlay").addClass('overlay-open');

	$('.js a[href="#modal"]').on("click", function (e) {
		$(".js .overlay").addClass("overlay-open");
	});
	$(".js .modal .btn-close").on("click", function (e) {
		e.preventDefault();
		$(".js .overlay").removeClass("overlay-open");
	});

	var modal = document.getElementById("modal");

	// When the user clicks anywhere outside of the modal, close it
	window.onclick = function (event) {
		if (event.target == modal) {
			modal.classList.removeClass("overlay-open");
		}
	};

	// Scrolling overlay

	var lastScrollTop = 0;
	$(window).scroll(function (event) {
		var st = $(this).scrollTop();
		if (st < lastScrollTop) {
			$(".overlay").addClass("scroll");
		} else {
			$(".overlay").removeClass("scroll");
		}
		lastScrollTop = st;
	});

	//Menu Hamburger

	$(".nav-expander").on("click", function (e) {
    e.preventDefault();
    
    // 1. Facciamo il toggle della classe sul body
    var body = $("body");
    body.toggleClass("nav-expanded");
    
    // 2. Verifichiamo se ora è aperto
    var isOpen = body.hasClass("nav-expanded");
    
    // 3. Prepariamo il testo corretto
    var labelText = isOpen ? "Chiudi il menu" : "Apri il menu";
    
    // 4. Aggiorniamo dinamicamente tutti gli attributi
    $(this)
        .attr("aria-expanded", isOpen) // Comunica lo stato (true/false)
        .attr("aria-label", labelText) // Cambia l'etichetta tecnica
        .find(".sr-only").text(labelText); // Cambia il testo per screen reader
});


	// Hero Carousel

	$(".hero-carousel").slick({
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		//lazyLoad: 'ondemand',

		responsive: [
			{
				breakpoint: 768, //fino a
				settings: {
					arrows: false,
				},
			},
		],
	});

	// Carousel pagina dettaglio

	$(".slider-detail").slick({
		//dots: true,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		centerMode: true,
		variableWidth: true,
		centerPadding: "0",

		responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
				},
			},
		],
	});

	// Slick lightbox
	// se matcha da 768px in su, si attiva il lightbox
	var mq = window.matchMedia("(min-width: 768px)");

	if (mq.matches) {
		$(".slider-detail").slickLightbox({
			src: "src-full",
			itemSelector: "div img",
		});
	}

	/* $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.slider-nav',
        //centerMode: true
        //variableWidth: true
    });

    $('.slider-nav').slick({
        arrows:false,
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        centerMode: true,
        focusOnSelect: true
        //variableWidth: true
    });*/

	//all'avvio del modal la prima slide non si vede
	// --> So manually refresh positioning of slick
	/*$('a#open').on("click", function() { 
        $('.overlay').addClass('overlay-open'); 
        $('.slider-for').slick('setPosition');  
        $('.slider-nav').slick('setPosition'); 
    });

    $('.btn-close').on('click',function(e){
        e.preventDefault();
        $('.overlay').removeClass('overlay-open'); 
        $('.slider-for').unslick;  
        $('.slider-nav').unslick; 
    });*/

	// gallery grande pagina foto mansarde
	$(".sfoglia").slick({
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		lazyLoad: "ondemand",
		//lazyLoad: "progressive",
		//lazyLoad: "anticipated",
	});

	$(document).on("click", ".thumbnails a.thumb", function (e) {
		e.preventDefault();
		$(".sfoglia").slick("slickGoTo", $(".thumbnails a.thumb").index(this), true);
		$(".big")[0].showModal(); 
		$(".sfoglia").slick("setPosition");
		/* $(".big").addClass("openThumb");
        $(".thumbnails a.thumb").attr('aria-hidden', true); */
	});
	/*
    $('.thumbnails a.thumb').on('click',function(e){
        e.preventDefault();
        $('.sfoglia').slick('slickGoTo',$('.thumbnails a.thumb').index(this),true);
        $('.big').addClass('openThumb');
    })
    */

	$(document).on("click", ".big .close", function (e) {
		$(".big")[0].close();
		/* $(".big").removeClass("openThumb");
        $(".thumbnails a.thumb").removeAttr('aria-hidden'); */
	});
	/*
    $('.big .close').on('click',function(){
        $('.big').removeClass('openThumb');
    })
    */

	// Test slideshow infinito
	/*
    $(document).on('click', '.slick-prev, .slick-next', function(e) {
        var currSlide = $('.sfoglia .slick-current.slick-active').attr('data-slick-index');
        console.log('currSlide = '+currSlide);
    });
    */

	/*
    $(document).on('beforeChange', '.sfoglia', function(e, slick, currentSlide, nextSlide) {
        console.log('beforeChange - currentSlide = '+currentSlide);
        console.log('beforeChange - nextSlide = '+nextSlide);
    });
    */

	//slider categorie

	$(".slider-category").slick({
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		centerMode: false,
		variableWidth: true,
		//lazyLoad: 'ondemand',
		lazyLoad: "progressive",

		responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
				},
			},
		],
	});

	//slider contenuti articolo

	$(".slider").slick({
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		variableWidth: true,
		arrows: false,
		responsive: [
			{
				breakpoint: 2561,
				settings: {
					infinite: false,
					slidesToShow: 2,
					slidesToScroll: 1,
					arrows: true,
				},
			},
			{
				breakpoint: 992,
				settings: {
					infinite: false,
					arrows: false,
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 601,
				settings: {
					infinite: false,
					arrows: false,
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	// Slider correlati home
	$(".sliderCorrelati__slider").slick({
		infinite: false,
		slidesToShow: 3.5,
		slidesToScroll: 1,
		arrows: true,
		lazyLoad: "ondemand",
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					infinite: false,
					slidesToShow: 3.5,
				},
			},
			{
				breakpoint: 768,
				settings: {
					infinite: false,
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 480,
				settings: {
					infinite: false,
					slidesToShow: 1,
				}
			}
		],
	});

	// Slider Guide home
	$(".sliderGuide__slider").slick({
		infinite: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		//prevArrow: null,
		lazyLoad: "ondemand",
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3.5,
				},
			},
			{
				breakpoint: 1280,
				settings: {
					slidesToShow: 4,
				},
			},
		],
	});

// Slider Before After
$('.beforeAfterSlider').on('init reInit afterChange', function(event, slick, currentSlide){
    // Rimuove il focus da tutti gli switch nelle slide
    $('.slick-slide [role="switch"]').attr('tabindex', '-1');
    // Lo ripristina solo per la slide attiva (anche se sono più di una)
    $('.slick-active [role="switch"]').attr('tabindex', '0');
});

	$(".beforeAfterSlider").slick({
		infinite: false,
		slidesToShow: 2,
		slidesToScroll: 1,
		arrows: true,
		responsive: [
			{
				breakpoint: 2561,
				settings: {
					infinite: false,
					slidesToShow: 1.75,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 992,
				settings: {
					infinite: false,
					slidesToShow: 1.75,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 601,
				settings: {
					infinite: false,
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	

	//Fade masthead home
	$('.fadeSlick').slick({
		dots: false,
		arrows: false,
		infinite: true,
		fade: true,
		cssEase: 'linear',
		autoplay: true,
		autoplaySpeed: 2500
		});

	// navigazione tastiera gallery
	var $carousel = $(
		".hero-carousel, .slider-detail, .sfoglia, .slider-category "
	);
	$(document).on("keydown", function (e) {
		if (e.keyCode == 37) {
			$carousel.slick("slickPrev");
		}
		if (e.keyCode == 39) {
			$carousel.slick("slickNext");
		}
	});

	/*$('.slider-category').slick({
        infinite: false,
        speed: 300,
        slidesToShow: 7,
        centerMode: false,
        variableWidth: false,
        lazyLoad: 'progressive',

        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 6
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 600,
                settings: {
                    arrows: false
                }
            },


            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]

    });
*/

	// apertura lightbox immagini articoli

	//$(".centrale-wrap").slickLightbox({
	$(".single-post .page-articolo")
		.slickLightbox({
			src: "href",
			itemSelector: "a.zoomIcon",
			//       swipe:!1,
			//        touchMove: false

			slick: {
				swipe: false,
			},
		})
		.on({
			"show.slickLightbox": function () {
				$("body").css("overflow", "hidden");
			},
			"hide.slickLightbox": function () {
				$("body").css("overflow", "initial");
			},
		});

	// CTA sticky bottom
	$(".toggle-bottom-row").click(function () {
		$(".bottom-row").toggleClass("is-closed");
	});

	// Fascetta progettisti
	$(".fascetta .close").click(function () {
		$(".fascetta").slideUp("slow");
	});

	//Search
	$("#open-search, #open-search-mobile, #open-search-link").on(
		"click",
		function (e) {
			e.preventDefault();
			$(".search-form-wrapper").addClass("search--open");
			$(".search__input").focus();
			$("main").addClass("main-wrap--move");
		}
	);
	$(".search-form-wrapper button").on("click", function () {
		$(".search-form-wrapper").removeClass("search--open");
		$("main").removeClass("main-wrap--move");
	});

	/* $("a[href='#searching-search'], a[href='#searching-search-mobile']").on('click',function(e){
        $('.search-form-wrapper').addClass('open');
    });
    $('.search-form-wrapper .btn-close').on('click',function(e){
        e.preventDefault();
        $('.search-form-wrapper').removeClass('open');  
    });*/
	document.addEventListener("keyup", function (ev) {
		// escape key.
		if (ev.keyCode == 27) {
			$(".search-form-wrapper").removeClass("search--open");
			$("main").removeClass("main-wrap--move");
		}
	});

	// disable scroll wheel on iframe google map
	$(".map").click(function () {
		$(".map iframe").css("pointer-events", "auto");
	});

	$(".map").mouseleave(function () {
		$(".map iframe").css("pointer-events", "none");
	});

	// Icona immagini lightbox
	$(".single-post img")
		.parent("a")
		.not('[href*="video.velux"], .noZoom')
		.addClass("zoomIcon");
	//$( ".single-post img").parent('a').addClass('zoomIcon');

	// Inibisco i link della gallery foto finche' non viene caricato il js del lightbox (deferred)
	$(".thumbnails a.thumb").on("click", function (e) {
		e.preventDefault();
	});

	if ($("body").hasClass("post-type-archive-faq")) {
		if (window.location.hash !== "") {
			var myFaqID = window.location.hash;
			$("html, body").animate(
				{
					scrollTop: $(myFaqID).offset().top - 150,
				},
				1
			);
			/*
            var myFaqID = window.location.hash;
            var lastScrollTop = 0;
            $(myFaqID).css("padding-top", "150px");
            setTimeout(
                $(window).scroll(function(e) {
                    var st = $(this).scrollTop();
                    if (st > lastScrollTop){
                        <?php // downscroll code ?>
                    } else {
                        <?php // upscroll code ?>
                        $(myFaqID).css("padding-top", "0"); 
                        //$(myFaqID).animate({ "padding-top": 0, }, 200);
                    }
                    lastScrollTop = st; 
                }), 
            1000);
            */
		}
	}

	if ($("body").hasClass("page-template-pagina-guide")) {
		if (window.location.hash !== "") {
			var myTarget = window.location.hash;
			//console.log(myTarget);
			$("html, body").animate(
				{
					scrollTop: $(myTarget).offset().top - 130,
				},
				1
			);
		}
	}

	var countIscrivitiClick = 0;
	$(document).on("click", ".primary-nav .btn-primary", function (e) {
		e.preventDefault();

		var offsetTop = 125;
		//var offsetTop = 175;
        if ($('body').hasClass('home')) offsetTop = 125;

		var isMobile = $(".nav-expander").is(":visible");

		/*
        countIscrivitiClick++;
        if (! isMobile && countIscrivitiClick == 1) {
            offsetTop = -175;
        }
        */

		$("html, body").animate(
			{
				scrollTop: $("#guida-mansarda").offset().top - offsetTop,
				//scrollTop: $("#newsletter_form").offset().top - offsetTop,
			},
			1000
		);

		if (isMobile) {
			$(".nav-expander").click();
		}
	});

	// Copy link
	/* $('.buttonCopyText').on("click", function (event) {
		event.preventDefault();

		var copyText = $(this).prev('.inputCopyText');
		copyText[0].select();
		copyText[0].setSelectionRange(0, 99999); // For mobile devices
		document.execCommand("copy");

		$(this).find('.copyTextTooltip').css('display', 'block');
		//document.execCommand("copy");
		setTimeout(function () {
			$(this).find('.copyTextTooltip').css('display', 'none');
		}, 1000);
	}); */
	
$('.buttonCopyText').on("click", function (event) {
    event.preventDefault();

    var $btn = $(this);

    var textToCopy = $btn.prev().val();
    //var textToCopy = $('#textToCopy').val();

    var $status = $btn.next();
    //var $status = $('#copyStatus');

    var $tooltip = $btn.find('.copyTextTooltip');

    // Funzione per gestire il feedback visivo e vocale
    function showSuccess() {
        $tooltip.show();
        $status.text("Link copiato negli appunti");
        setTimeout(function () {
            $tooltip.hide();
            $status.text(""); 
        }, 2000);
    }

    // Prova prima con la moderna Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(textToCopy).then(showSuccess);
    } else {
        // FALLBACK: Metodo classico per contesti HTTP o browser datati
        var $tempInput = $("<input>");
        $("body").append($tempInput);
        $tempInput.val(textToCopy).select();
        try {
            document.execCommand("copy");
            showSuccess();
        } catch (err) {
            $status.text("Errore durante la copia");
        }
        $tempInput.remove();
        // Riporta il focus sul bottone per non perdere l'orientamento (A11y)
        $btn.focus();
    }
});


    

// Slider Before After
	/* $('.beforeAfterSlider div[role="switch"]').click(function(){
		if(($(this).siblings('.beforeAfterSliderImg').find('img.light')).hasClass("fadeOut"))
			{
				$(this).siblings('.beforeAfterSliderImg').find('img.light').toggleClass('fadeOut fadeIn').siblings('img').toggleClass('fadeOut fadeIn');
			}
		else {
				$(this).siblings('.beforeAfterSliderImg').find('img.light').toggleClass('fadeIn fadeOut').siblings('img').toggleClass('fadeOut fadeIn');
			}
	}); */

// Funzione unica per cambiare lo stato
function toggleSwitch(element) {
    const $this = $(element);
    const isChecked = $this.attr('aria-checked') === 'true';
    const newState = !isChecked;

    $this.attr('aria-checked', newState.toString());

    const $slide = $this.closest('.slick-slide');
    const $imgAfter = $slide.find('img.light');
    const $imgBefore = $slide.find('img').not('.light');

    if (newState) {
        $imgAfter.addClass('fadeIn').removeClass('fadeOut');
        $imgBefore.addClass('fadeOut').removeClass('fadeIn');
    } else {
        $imgAfter.addClass('fadeOut').removeClass('fadeIn');
        $imgBefore.addClass('fadeIn').removeClass('fadeOut');
    }
}

// 1. GESTIONE CLICK (Fase di cattura per superare Slick)
document.addEventListener('click', function(e) {
    const switchEl = e.target.closest('[role="switch"]');
    if (switchEl) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        toggleSwitch(switchEl);
    }
}, true);

// 2. GESTIONE TASTIERA
document.addEventListener('keydown', function(e) {
    const switchEl = e.target.closest('[role="switch"]');
    
    if (switchEl) {
        // Intercettiamo solo Invio (Enter) o Spazio ( )
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault(); // Impedisce lo scroll della pagina con lo Spazio
            e.stopPropagation();
            e.stopImmediatePropagation();
            toggleSwitch(switchEl);
        }
    }
}, true);


});

// DEFERRED IMAGES
/*
function init() {
    var imgDefer = document.getElementsByTagName('img');
    for (var i=0; i<imgDefer.length; i++) {
        if(imgDefer[i].getAttribute('data-src')) {
            imgDefer[i].setAttribute('src',imgDefer[i].getAttribute('data-src'));
            imgDefer[i].classList.add("app")
        } } }
window.onload = init;
*/

// FALLBACK OBJECT-FIT IE
if (!Modernizr.objectfit) {
	$(
		".correlato__img, .slider-category, .archivio__img, .two-blocks__img, .categoria__selected__list, .masthead:not(.home)"
	).each(function () {
		//console.log("Sono in FALLBACK OBJECT-FIT IE");

		var childImg = $(this).find("img");

		var imgSrc = childImg.attr("src");
		if (!imgSrc) imgSrc = childImg.attr("data-src");
		if (!imgSrc) imgSrc = childImg.attr("data-src-objectfit");
		//console.log(imgSrc);

		if (!imgSrc) return;

		var fitType = "cover";
		/*
        if($(this).data('fit-type')) {
            fitType = $(this).data('fit-type');
        }
        */

		$(this).css({
			background:
				'transparent url("' + imgSrc + '") no-repeat center center/' + fitType,
		});
		childImg.remove();
	});
}

function isValInDataLayer(myVal) {
	if (typeof dataLayer === "object")
		for (i in dataLayer)
			if (typeof dataLayer[i].event !== "undefined" && dataLayer[i].event == myVal)
				return true;
	return false;
}

/* mgigli 20221104 - Spostato in file a parte (hubspot-forms.js) caricato in head dopo le librerie Hubspot
// Form Hubspot (Guida Mansarda)
// NB per istanziare la stessa form piu' volte devo ripetere i blocchi, perche' il target puo' essere solo un elemento singolo
if (typeof hbspt !== "undefined") {
	hbspt.forms.create({
		target: "#newsletter_form",
		css: "",
		portalId: "427615",
		formId: "2334882c-074b-4a54-a762-3dc5f3510721",
		onFormSubmit: function ($form) {
			// Tracking con Google Tag Manager
			if (typeof dataLayer === "object") {
				dataLayer.push({ event: "iscrizione-guida-mansarda" });
			} else {
				console.log("dataLayer.push({'event': 'iscrizione-guida-mansarda'});");
			}
		},
	});
	hbspt.forms.create({
		target: "#newsletter_form_footer",
		css: "",
		portalId: "427615",
		formId: "2334882c-074b-4a54-a762-3dc5f3510721",
		onFormSubmit: function ($form) {
			// Tracking con Google Tag Manager
			if (typeof dataLayer === "object") {
				dataLayer.push({ event: "iscrizione-guida-mansarda" });
			} else {
				console.log("dataLayer.push({'event': 'iscrizione-guida-mansarda'});");
			}
		},
	});
}
*/

// Elementi con animazione in entrata
//const animated_elements = [].slice.call(document.querySelectorAll('.benefit'));
//animated_elements.forEach(animated_element => observer.observe(animated_element)); // add an element to the set of target elements being watched

// IntersectionObserver Supported
const config = {
	root: null, // relative to document viewport
	rootMargin: "50px 0px", // margin around root. Values are similar to css property. Unitless values not allowed
	threshold: 0, // visible amount of item shown in relation to root
};

let observer = new IntersectionObserver(onChange, config);

function onChange(changes, observer) {
	changes.forEach((change) => {
		if (change.intersectionRatio > 0) {
			// check if the target is visible (greater than 0)
			// Stop watching and load the image

			if (
				change.target.tagName.toLowerCase() == "img" ||
				change.target.tagName.toLowerCase() == "source"
			) {
				loadImage(change.target);
			} else {
				enterClass(change.target);
			}

			observer.unobserve(change.target);
		}
	});
}

function loadImage(image) {
	//image.classList.add('fade-in');
	if (image.dataset && image.dataset.src) {
		image.src = image.dataset.src;
	}

	if (image.dataset && image.dataset.srcset) {
		image.srcset = image.dataset.srcset;
	}
}

function enterClass(el) {
	if (!el.classList.contains("entering")) {
		el.classList.add("entering");
	}
}

// Immagini da caricare in LazyLoad
const images = [].slice.call(
	document.querySelectorAll("[data-src], [data-srcset]")
);
//const images = [].slice.call(document.querySelectorAll('[data-src]'));
images.forEach((img) => observer.observe(img)); // add an element to the set of target elements being watched

//Reload on resize
/*
var windowWidth = $(window).width();
$(window).resize(function () {
	if ($(window).width() != windowWidth) {
		windowWidth = $(window).width();
		setTimeout(function () {
			window.location.reload();
		});
	}
});
*/


// Intersection observer per attivare voci menu contestuale 
if (window.matchMedia("(min-width: 768px)").matches) {  

const observerHeadingOptions = {
    root: null,
    rootMargin: "0px", 
	threshold: 0.75
    //threshold: [0, 0.25, 0.5, 0.75, 1] // trigger a diversi livelli di visibilità
};

const observerHeading = new IntersectionObserver(entries => {
	entries.forEach(entry => {
		const id = entry.target.getAttribute('id');
		if (entry.intersectionRatio > 0) {
            document.querySelectorAll('.article__menu li').forEach(item => {
                item.classList.remove('active');
            });
			document.querySelector(`.article__menu li a[href="#${id}"]`).parentElement.classList.add('active');
		} 
		/* else {
            document.querySelector(`.article__menu li a[href="#${id}"]`).parentElement.classList.remove('active');
        } */
    });
}, observerHeadingOptions);


document.querySelectorAll('h2 span[id]').forEach((h2) => {
	observerHeading.observe(h2);
});
}



'use strict';

class Switch {
  constructor(domNode) {
    this.switchNode = domNode;
    this.switchNode.addEventListener('click', () => this.toggleStatus());
    this.switchNode.addEventListener('keydown', (event) =>
      this.handleKeydown(event)
    );
  }

  handleKeydown(event) {
    // Only do something when space or return is pressed
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleStatus();
    }
  }

  // Switch state of a switch
  toggleStatus() {
    const currentState =
      this.switchNode.getAttribute('aria-checked') === 'true';
    const newState = String(!currentState);

    this.switchNode.setAttribute('aria-checked', newState);
  }
}

// Initialize switches
window.addEventListener('load', function () {
  // Initialize the Switch component on all matching DOM nodes
  Array.from(document.querySelectorAll('[role^=switch]')).forEach(
    (element) => new Switch(element)
  );
});


